export default __webpack_public_path__ + "static/media/hipercard.92339365.png";